export enum FlightModifyStatus {
  ChangeRequested = "CHANGE REQUESTED",
  CancelRequested = "CANCEL REQUESTED",
}

export enum BOOKING_STATUS {
  Cancelled = "Cancelled",
  Confirmed = "Confirmed",
}

export enum TRIP_TYPES {
  OneWay = "One Way",
  RoundTrip = "Round Trip",
  MultiCity = "Multi City",
}

export enum PROMO_STATUS {
  Applied = "APPLIED",
  NotEligible = "NOT_ELIGIBLE",
  NotApplied = "NOT_APPLIED",
}
